// extracted by mini-css-extract-plugin
export default {"hcs__preview-snippets":"helpful-content_hcs__preview-snippets__nakRF","text":"helpful-content_text__cJDH8","hcs__delete-snippets":"helpful-content_hcs__delete-snippets__wIIDQ"};